import { useEffect, useState } from 'react';
import { getScrollYOffset } from '@toss/utils';
import { debounce } from 'es-toolkit';

export function useScrollYPosition(debounceMs = 100) {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = debounce(() => {
      setScrollY(getScrollYOffset());
    }, debounceMs);

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [debounceMs]);

  return scrollY;
}
